import { render } from "./InvAdvMenu.vue?vue&type=template&id=d48ba0c6&scoped=true&ts=true"
import script from "./InvAdvMenu.vue?vue&type=script&lang=ts"
export * from "./InvAdvMenu.vue?vue&type=script&lang=ts"

import "./InvAdvMenu.vue?vue&type=style&index=0&id=d48ba0c6&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d48ba0c6"]])

export default __exports__